package com.fireavert.fire_risk.data_models

import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant
import kotlinx.serialization.Serializable

@Serializable
data class TenantFireRiskDataModel(
    var score: Double,
    var riskRating: Int = 0,
    val propertyId: Int,
    val unitId: Int,
    val unitNumber: String,
    val propertyName: String,
    val dateAdded: Instant = LocalDateTime.parse("2023-01-01T00:00:00").toInstant(timeZone = TimeZone.Companion.UTC)
) {
    companion object {
        val emptyModel = TenantFireRiskDataModel(
            score = 0.0,
            riskRating = 0,
            propertyId = 0,
            unitId = 0,
            unitNumber = "unknown",
            propertyName = "unknown"
        )
    }
}
